import type { Router } from 'vue-router'
import { getToken } from '@/utils/storage'
import { useOrderStore } from '@/stores/order'

/** 白名单：无需登录即可访问 */
const whiteList = ['/login', '/404']

export function setupRouterGuard(router: Router) {
  router.beforeEach((to) => {
    const hasToken = !!getToken()

    if (to.meta.requiresAuth && !hasToken && !whiteList.includes(to.path)) {
      // 与 stores/user.ts 的 resetToken 保持一致：
      // offline_payment 场景只带 productId 和 orderNo，其余场景带除 orderNo 和 pageFrom 的其他参数
      const orderStore = useOrderStore()
      const { orderNo, pageFrom, ...rest } = orderStore.orderQuery || {}
      const query = pageFrom === 'offline_payment'
        ? { productId: rest.productId, orderNo }
        : { ...rest }
      return {
        path: '/login',
        query: { ...query },
        replace: true,
      }
    }

    return true
  })

  router.afterEach((to) => {
    document.title = to.meta.title || import.meta.env.VITE_APP_TITLE
  })

  router.onError((error) => {
    // 新版本发布后旧 chunk 失效，刷新页面重新加载
    if (
      /Failed to fetch dynamically imported module|Importing a module script failed/.test(
        error.message,
      )
    ) {
      location.reload()
    }
  })
}
